import styled from 'styled-components';

import { IconRegularGift, HorizontalChevron } from '@notino/react-styleguide-v20';

import { StyledCartWrapper } from '@styles/generalStyles';
import { CypressTestNamespace } from '@utils/test';

export const StyledCollapsibleContentHandler = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const StyledGiftIcon = styled(IconRegularGift)`
  cursor: pointer;
`;

export const StyledGiftComponentTitle = styled(StyledCartWrapper).attrs(() => ({
  className: `${CypressTestNamespace.ECartPageGifts.GIFT_COLLAPSIBLE_SECTION}`,
}))`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-weight: bold;
`;

export const StyledHorizontalChevron = styled(HorizontalChevron)`
  padding-left: 0.5rem;
`;
